import { ConnectWalletBus } from "./connect-wallet-bus";
import { DisconnectedTrigger } from "./disconnected-trigger";

interface ConnectWalletProps {
  className?: string;
}

export function ConnectWallet({ className }: ConnectWalletProps): JSX.Element {
  return (
    <DisconnectedTrigger
      className={className}
      onClick={() => {
        ConnectWalletBus.publish();
      }}
    />
  );
}
